import {
  ExploreNoInsightsResults,
  ExploreResults,
  insight,
  PostExploreRequestFilters,
  SortByParams,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

interface FetchExploreResultsParams {
  filters: PostExploreRequestFilters;
  page?: {
    number: number;
    size: number;
  };
  sortBy?: SortByParams;
  combined?: boolean;
  signal?: AbortSignal;
}

interface FetchExploreNoInsightsResultsParams {
  filters: {
    entity_tag: {
      values: { tags: string[] }[];
    };
  };
  signal?: AbortSignal;
}

export const fetchExploreResults = ({
  filters,
  sortBy,
  combined = true,
  page,
  signal,
}: FetchExploreResultsParams) => {
  return wretchRequest<ExploreResults>(insight.postExplore.path, {
    method: 'post',
    body: {
      filters,
      sort_by: sortBy,
      combined,
      page,
    },
    signal,
  });
};

export const fetchExploreNoMatchedResults = ({
  filters,
  page,
  signal,
}: Omit<FetchExploreResultsParams, 'combined'>) => {
  return wretchRequest<ExploreResults>(insight.postExploreNoMatched.path, {
    method: 'post',
    body: {
      filters,
      page,
    },
    signal,
  });
};

export const fetchExploreNoInsightsResults = ({
  filters,
  signal,
}: FetchExploreNoInsightsResultsParams) => {
  return wretchRequest<ExploreNoInsightsResults>(
    insight.postExploreNoInsights.path,
    {
      method: 'post',
      body: {
        filters,
      },
      signal,
    }
  );
};
